module.exports = __webpack_public_path__ + "img/globe-stand.e1b64d84.svg";